<template>
  <Navbar />
  <div class="content-wrapper">
    <div class="main-content">
      <section class="pt-60 pb-60 mt-60 lg:pt-30 overflow-hidden">
        <div class="container pt-10">
          <div class="row">
            <div class="col-lg-8 col-md-7 lg:order-1" data-aos="fade-up" :data-aos-delay="200">
              <EventContent />
            </div>

            <div class="col-lg-4 col-md-5 lg:order-2" data-aos="fade-up" :data-aos-delay="250">
              <EventsSidebar />
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import EventContent from "@/components/Events/EventContent.vue";
import EventsSidebar from "@/components/Events/EventsSidebar.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    EventsSidebar,
    FooterItem,
    EventContent,
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    updateHeadMeta(
      eventTitle,
      eventDescription,
      eventDate,
      eventImageUrl,
      eventUrl
    ) {
      const title =
        this.currentLanguage === "ar"
          ? `${eventTitle} - حدث Planning Force | ابدأ رحلتك التعليمية`
          : `${eventTitle} - Event | Planning Force | Start Your Learning Journey`;

      const description =
        this.currentLanguage === "ar"
          ? eventDescription ||
          "انضم إلى حدثنا القادم لتعلم المزيد حول الموضوعات الحالية في عالم التعليم الإلكتروني والتدريب."
          : eventDescription ||
          "Join our upcoming event to learn more about current topics in the world of e-learning and training.";

      const keywords =
        this.currentLanguage === "ar"
          ? `حدث, ${eventTitle}, تعلم, تعليم إلكتروني, Planning Force, تدريب`
          : `event, ${eventTitle}, learning, e-learning, Planning Force, training`;

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "Planning Force"
                : "Planning Force",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content:
              eventImageUrl || "https://example.com/default-event-image.jpg",
          }, // Replace with your image URL
          {
            property: "og:url",
            content: eventUrl || "https://example.com/event/1",
          }, // Replace with your event page URL
          { property: "og:type", content: "event" },
          {
            property: "og:locale",
            content: this.currentLanguage === "ar" ? "ar_AR" : "en_US",
          },
          { property: "og:time", content: eventDate || "2024-12-30T18:00:00Z" }, // Replace with event date and time

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content:
              eventImageUrl || "https://example.com/default-event-image.jpg",
          }, // Replace with your image URL
        ],
      });
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta(
          "E-Learning Trends 2024",
          "Join us for a deep dive into the latest trends in e-learning and how they are shaping the future of education.",
          "2024-12-30T18:00:00Z",
          "https://example.com/images/e-learning-trends-2024.jpg",
          "https://example.com/event/e-learning-trends-2024"
        );
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
